// extracted by mini-css-extract-plugin
module.exports = {"downloadCodeContainer":"QRCodeDownload_downloadCodeContainer__s_eut","storeBadgeContainer":"QRCodeDownload_storeBadgeContainer__evN8v"};